import { useContext } from "react";
import NewSeasonChecklist from "../../dashboards/admin/components/NewSeasonChecklist";
import { useAuthUser } from "../../hooks/useAuthUser";
import { SeasonContext } from "../../store/SeasonContext";
import LogoutButton from "../LogoutButton";
import { Link, NavLink } from "react-router-dom";
import { adminMenuOptions, employeeMenuOptions } from "./Menu.helpers";
import { HamburgerMenuContext } from "../../store/HamburgerMenuContext";
import { ReactComponent as Logo } from "../../../../assets/images/logo/LOGO.svg";
const DashboardMenuContent = () => {
  const { isAdmin, isEmployee, hasCSASubscription } = useAuthUser();
  const { areWeInSeason } = useContext(SeasonContext);
  const { closeHamburgerMenu } = useContext(HamburgerMenuContext);

  if (!(isAdmin || isEmployee)) {
    return null;
  }

  const optionsToRender = isAdmin ? adminMenuOptions : employeeMenuOptions;
  const menuLinks = optionsToRender.map((link) => {
    return (
      <NavLink
        className={({ isActive }) =>
          isActive ? "active-nav-link" : "nav-link"
        }
        key={link.url}
        to={link.url}
        onClick={closeHamburgerMenu}
      >
        {link.text}
      </NavLink>
    );
  });

  return (
    <div className="menu-content hidden-scrollbar">
      <div className="nav-menu">
        <Link to="/" className="menu-logo-link" onClick={closeHamburgerMenu}>
          <Logo className="menu-logo" aria-label="Alnarp's Farm Logo" />
        </Link>
        {menuLinks}
        {!areWeInSeason && isAdmin && <NewSeasonChecklist />}
      </div>

      <div className="personal-menu-links-container-sidebar">
        {hasCSASubscription && (
          <Link
            className="nav-link"
            to="/dashboard/client"
            onClick={closeHamburgerMenu}
          >
            My Subscription
          </Link>
        )}
        <LogoutButton type="nav-link" />
      </div>
    </div>
  );
};

export default DashboardMenuContent;
